import React from 'react';
import { Field } from 'redux-form';
import { translate } from 'admin-on-rest';
import equal from 'deep-equal';
import {
  MenuItem,
  SelectField,
} from 'material-ui';
import plz from 'await-plz';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
};

const menuItems = (value, venues) => (
  venues && venues.sort((a, b) => {
    if (a.placeId.toLowerCase() < b.placeId.toLowerCase()) return -1;
    if (a.placeId.toLowerCase() > b.placeId.toLowerCase()) return 1;
    return 0;
  }).map((venue) => (
    <MenuItem
      key={venue.placeId}
      value={venue.objectId}
      primaryText={venue.placeId}
      checked={typeof value === 'string' ? value === venue.objectId : value.includes(venue.objectId)}
      insetChildren
    />
  ))
);

// eslint-disable-next-line no-shadow
const VenueList = translate(({ input: { value, onChange }, venues, translate, multiple, label, fullWidth }) => (
  <div style={styles.wrapper}>
    <div style={{ width: '100%' }}>
      <SelectField
        fullWidth={fullWidth}
        floatingLabelText={label}
        hintText={translate('resources.venues.fields.placeId')}
        multiple={multiple}
        value={value}
        onChange={(e, i, val) => {
          onChange(val);
        }}
      >
        {menuItems(value, venues)}
      </SelectField>
    </div>
  </div>
));

export class BookingIdInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      venues: [],
    };
  }

  componentDidMount = async () => {
    const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
    const [resErr, venues] = await plz(fetch(`${url}/utils/parse/place`, { credentials: 'include' }));
    if (resErr || !venues) return console.error('failed to fetch venue', resErr);
    return this.setState({ venues });
  };

  shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || !equal(this.state, nextState);

  render() {
    const { source, label, multiple, fullWidth } = this.props;
    return (
      <Field
        name={source}
        component={(props) => (
          <VenueList
            {...props}
            {...this.state}
            multiple={multiple}
            fullWidth={fullWidth}
            label={label}
            handleVenueChange={this.handleVenueChange}
            handlePreferredChange={this.handlePreferredChange}
          />
        )}
      />
    );
  }
}

export default translate(BookingIdInput);
